import { useCallback } from 'react';
import { EndPoints } from 'src/config';
import { useFetcher } from 'src/hooks/useFetcher';

export type SubmitClientDeliveryRequestPayload = {
  shippingId: string;
  name: string;
  email: string;
  tel: string;
  address: string;
  city: string;
  zipCode: string;
  optin: boolean;
  lat?: number;
  long?: number;
  captchaToken: string;
  promoCode?: string;
};

export const useSubmitClientDeliveryRequest = () => {
  const { data, fetcher, isLoading, error } = useFetcher<any>(null);
  const submitClientDeliveryRequest = useCallback(
    async (payload: SubmitClientDeliveryRequestPayload) => {
      const response = await fetcher(EndPoints.publicClientDeliveryRequest, {
        requiredToken: false,
        method: 'POST',
        body: {
          ...payload,
          // Hardcoded country for now
          country: 'FR',
          language: 'fr_FR',
        },
      });
      return response;
    },
    [fetcher],
  );

  return {
    submitClientDeliveryRequest,
    isLoading,
    error,
    data,
  };
};
